module.exports = __webpack_public_path__ + "static/media/close.3f436264.svg";